
import { Options, prop, Vue } from "vue-class-component";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import debounce from "lodash/debounce";
import ToggleV2 from "@/app/ui/components/toggle-v2/index.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { getPhoneDisplayCode } from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import { codePhoneCountry } from "@/app/ui/views/shipment/booking/booking-utils";
import SelectPhoneCountry from "@/app/ui/views/shipment/booking/component/select-phone-country.vue";

export type SttReturnErrorSectionProp = {
  phone: boolean;
};

// codRej: {
//       receiverName: "",
//       receiverAddress: "",
//       district: "",
//       commision: "",
//       padCommision: "",
//       phone: "",
//       codAmountType: "",
//       codShipmentDiscount: ""
//     }

class Props {
  modelValue = prop<any>({
    required: true,
    type: Object,
  });
  form = prop<any>({
    required: true,
    type: Object,
  });
  error = prop<any>({
    default: {
      phone: false,
    },
  });
  isEdit = prop<boolean>({
    default: false,
  });
  cacheEdit = prop<any>({
    type: Object,
    default: {
      receiverName: "",
      receiverAddress: "",
      district: "",
      phone: "",
    },
  });
  isMY = prop<boolean>({
    default: false,
  });
}

@Options({
  components: {
    ToggleV2,
    SelectPhoneCountry
  },
})
class ClientBranchSection extends Vue.with(Props) {
  autoFillColumnDisabled = false;
  isFill = false;
  openFill = false;

  mounted(): void {
    this.fetchDistrictList("");
    if (!this.modelValue.phoneDialCode) {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        phoneDialCode: this.defaultDialCode
      });
    }
  }

  // district list
  fetchDistrictList = debounce((search: string) => {
    ClientRegistrationController.getDistrictList({
      search: search,
    });
  }, 250);

  get districtList() {
    return ClientRegistrationController.districtList;
  }

  get loadingDistrictList() {
    return ClientRegistrationController.loadingDistrictList;
  }

  get defaultDialCode() {
    return getPhoneDisplayCode(AccountController.accountData?.countryCode);
  }

  get errorCodRejStt() {
    return {
      error: this.error.codRejPhone,
      errorPhone: false,
      errorMandatory: false,
      errorPhoneCode: false,
      phoneCharMinimal: false,
      message: ""
    };
  }

  onSetCodPhone(v: string) {
    this.$emit("update:modelValue", { phone: v });
    this.validatePhone(v);
  }

  onSetCodPhoneDialCode(v: string) {
    this.$emit("update:modelValue", { phoneDialCode: v });
  }

  validatePhone(value: string) {
    this.error.codRejPhone = !/^\d+$/.test(value) || value.length < 8;
  }

  autoFill() {
    this.error.codRejPhone = false;
    this.openFill = false;
    this.isFill = !this.isFill;
    if (this.isFill) {
      this.autoFillColumnDisabled = true;
      this.modelValue.receiverName = this.form.companyName;
      this.modelValue.receiverAddress = this.form.address;
      this.modelValue.district = this.form.district;
      this.modelValue.phone = this.form.phone;
      this.modelValue.phoneDialCode =
        this.form.phoneDialCode || this.defaultDialCode;
      this.$emit("update:modelValue", { ...this.modelValue });
    } else {
      if (this.isEdit) {
        this.modelValue.receiverName = this.cacheEdit.receiverName;
        this.modelValue.receiverAddress = this.cacheEdit.receiverAddress;
        this.modelValue.district = this.cacheEdit.district;
        const raw = String(this.cacheEdit.phone || "")
          .replace(/^\+/, "")
          .replace(/\s/g, "");
        const p = codePhoneCountry(raw);
        this.modelValue.phone = p.number;
        this.modelValue.phoneDialCode = p.code;
      } else {
        this.modelValue.receiverName = "";
        this.modelValue.receiverAddress = "";
        this.modelValue.district = "";
        this.modelValue.phone = "";
        this.modelValue.phoneDialCode = this.defaultDialCode;
      }
      this.autoFillColumnDisabled = false;
      this.$emit("update:modelValue", { ...this.modelValue });
    }
  }

  get phoneCodePrefix() {
    return this.isMY ? "+60" : "+62";
  }
}
export default ClientBranchSection;
